import {activationTimePreparer} from "@/tools";
import {UpdateIvrProfileMutationVariables} from "./mutation.generated";
import {IvrProfile, convertSubmenus, greetingsToUpdateMenuMedia, ivrActionToUpdateButton, sortButtons} from "./tools";

export const createInitialData = (profile: IvrProfile | undefined): UpdateIvrProfileMutationVariables => {
    if (!profile)
        return {
            id: 0,
            name: "",
            instantConnect: false,
            timeout: 0,
            settings: {
                activationTimes: [],
                specialDays: [],
                stickyProfile: false,
            },
            greetings: [
                {
                    id: 0,
                    description: "",
                    file: undefined,
                    disabled: false,
                },
            ],
            menuMedia: [
                {
                    id: 0,
                    description: "",
                    file: undefined,
                    disabled: false,
                },
            ],
            submenus: [],
            buttons: [],
        };

    profile.actions.sort(sortButtons);

    const preparedActivationTimes = activationTimePreparer(profile.activationTimes);

    return {
        id: profile.id,
        name: profile.name,
        instantConnect: profile.instantConnect,
        timeout: profile.timeout,
        settings: {
            activationTimes: preparedActivationTimes,
            stickyProfile: profile.stickyProfile,
            specialDays: profile.specialDays,
        },
        greetings: greetingsToUpdateMenuMedia(profile.greetings, false),
        menuMedia: greetingsToUpdateMenuMedia(profile.greetings, true),
        buttons: profile.actions.map(ivrActionToUpdateButton),
        submenus: convertSubmenus(profile),
    };
};
